import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactContent } from '../components/contact/ContactContent';
export function ContactPage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-457" data-mp="srapm4kktnub">
      <Navigation data-id="element-458" data-mp="xpvre8fh8fkv" />
      <main className="flex-grow" data-id="element-459" data-mp="xoaw2glc8sly">
        <ContactContent data-id="element-460" data-mp="xokr4il8ppyi" />
      </main>
      <Footer data-id="element-461" data-mp="zd1aydl8uos" />
    </div>;
}